import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import { getHighInterestBanks, getBanksByName, getBanksByCertId } from "../actions";

var normalize = function normalize(offer) {
  return {
    name: get(offer, 'product.details.display_name.value'),
    altName: get(offer, 'product.institution.name'),
    subtitle: get(offer, 'product.institution.details.federally_insured.value'),
    issuer: get(offer, 'product.institution.details.display_name.value'),
    rating: get(offer, 'product.institution.details.nw_rating.value'),
    image: get(offer, 'product.institution.details.logo_url.value'),
    link: get(offer, 'derived_details.apply_link.value'),
    apy: get(offer, 'details.apy.value'),
    certId: get(offer, 'product.institution.details.cert_id.value'),
    offer: offer
  };
};

var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, getHighInterestBanks.success, function (state, _ref) {
  var _ref$offers = _ref.offers,
      offers = _ref$offers === void 0 ? [] : _ref$offers;
  return _objectSpread(_objectSpread({}, state), {}, {
    bestSavingsAccounts: offers.map(normalize)
  });
}), _defineProperty(_createReducer, getBanksByName.success, function (state, _ref2) {
  var _ref2$offers = _ref2.offers,
      offers = _ref2$offers === void 0 ? [] : _ref2$offers;
  return _objectSpread(_objectSpread({}, state), {}, {
    banks: offers.map(normalize)
  });
}), _defineProperty(_createReducer, getBanksByCertId.success, function (state, _ref3) {
  var _ref3$offers = _ref3.offers,
      offers = _ref3$offers === void 0 ? [] : _ref3$offers;
  return _objectSpread(_objectSpread({}, state), {}, {
    banks: offers.map(normalize)
  });
}), _createReducer), {});
export default reducer;